import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Modal, Form, Alert, ListGroup,
} from 'react-bootstrap';

const styles = {
  container: {
    backgroundColor: '#f8f9fa',
    borderRadius: '5px',
    padding: '20px',
    margin: '10px 0',
  },
  title: {
    color: '#333',
    marginBottom: '20px',
  },
  transactionCount: {
    color: '#FF8C00',
    marginBottom: '20px',
  },
  listItem: {
    border: 'none',
    backgroundColor: '#fff',
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    marginBottom: '10px',
    borderRadius: '5px',
  },
};

class TransactionConfirmationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      soidShouldBeGenResolve: true,
      reasonDropDownValue: '',
      textValue: '',
    };
  }

  handleReasonDropDownChange = (event) => {
    this.setState({ reasonDropDownValue: event.target.value, });
  };

  handleSoidShouldBeGenResolveChange = () => {
    this.setState(prevState => ({ soidShouldBeGenResolve: !prevState.soidShouldBeGenResolve, }));
  };

  handleTextChange = (event) => {
    this.setState({ textValue: event.target.value, });
  };

  calculateTotal = () => {
    const { transactions, } = this.props;
    return Object.keys(transactions).length;
  };

  renderV3Transactions = () => {
    const { transactions = {}, selectedLineItems = {}, } = this.props;
    const v3Transactions = Object.keys(transactions).filter(key => transactions[key].transactionType === 'V3');

    return (
      <div style={styles.container}>
        <h4 style={styles.title}>V3 Transactions Selected:</h4>
        {v3Transactions.length > 0 ? (
          <ListGroup variant="flush">
            {v3Transactions.map((key) => (
              <ListGroup.Item
                key={key}
                style={styles.listItem}
              >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', }}>
                  <div>{`${key}`}</div>
                  {selectedLineItems[key] && (
                    <div style={{ color: '#6c757d', }}>
                      <ul>
                        {Object.keys(selectedLineItems[key]).map((lineItem) => (
                          <li key={lineItem}>with line item: {lineItem}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        ) : (
          <p style={{ color: '#6c757d', }}>No V3 transactions selected.</p>
        )}
      </div>
    );
  };

  renderV2Transactions = () => {
    const v2Transactions = Object.keys(this.props.transactions).filter(key => this.props.transactions[key].transactionType === 'V2');

    return (
    <div style={styles.container}>
      <h4 style={styles.title}>V2 Transactions Selected:</h4>
      {v2Transactions.length > 0 ? (
        <ListGroup variant="flush">
          {v2Transactions.map((key) => (
            <ListGroup.Item
              key={key}
              style={styles.listItem}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                <div>{`${key}`}</div>
              </div>
            </ListGroup.Item>
          ))}
        </ListGroup>
      ) : (
        <p style={{ color: '#6c757d', }}>No V2 transactions selected.</p>
      )}
    </div>
    );
  };

  renderForm() {
    const { soidShouldBeGenResolve, reasonDropDownValue, textValue, } = this.state;

    return (
    <div style={styles.container}>
      <Form>
        <h4 style={styles.title}>Service Offering ID (SOID) for Selected Transactions</h4>
        <Form.Group className="mb-3" controlId="formBasicSwitch">
          <Form.Check
            type="switch"
            id="custom-switch"
            label={soidShouldBeGenResolve ? 'Set transactions to "gen_resolve"' : 'Set transactions to their originally issued SOID'}
            checked={soidShouldBeGenResolve}
            onChange={this.handleSoidShouldBeGenResolveChange}
          />
          <Form.Text className="text-muted">
            <p>
              Toggle this switch to determine the selected transactions&apos; SOID.
              When off, each transaction will revert to the originally issued SOID.
              When on, each transactions&apos; SOID will change to &quot;gen_resolve&quot;.
            </p>
          </Form.Text>
        </Form.Group>

        <h4 style={styles.title}>Reason for gen_resolve:</h4>
        <Form.Group className="mb-3" controlId="reasonForm.dropdown">
          <Form.Select onChange={this.handleReasonDropDownChange} value={reasonDropDownValue}>
            <option value="">Select a reason</option>
            <option value="DUPLICATE">Transaction was a duplicate</option>
            <option value="REFUND">Transaction had refund issued</option>
            <option value="REPROCESS">Transaction was reprocessed</option>
            <option value="VOID">Transaction was voided</option>
            <option value="TEST_TRANSACTION">Test Transaction</option>
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-3" controlId="reasonForm.additionalNote">
          <Form.Label>Additional Note <span style={{ color: 'red', }}>*</span></Form.Label>
          <Form.Control required as="textarea" rows={3} onChange={this.handleTextChange} value={textValue} placeholder="Please provide context as to why these transactions are being gen_resolve'd (e.g. incident, bug, etc)" />
          {textValue.trim().split(/\s+/).length < 3 && <Form.Text className="text-muted">Please enter at least 3 words.</Form.Text>}
        </Form.Group>
      </Form>
    </div>
    );
  }

  renderModalHeader() {
    return (
    <Modal.Header
      closeButton
      style={
        styles.container
      }
    >
      <Modal.Title style={styles.title}>Review Selected Transactions</Modal.Title>
    </Modal.Header>
    );
  }

  renderModalBody(total) {
    return (
    <Modal.Body style={
      styles.container
    }
    >
      <h5 style={styles.title}>Selected Transactions</h5>
      {this.renderV3Transactions()}
      {this.renderV2Transactions()}
      {this.renderForm()}
      {total === 0 ? (<Alert variant="warning">No Transactions Selected.</Alert>) : null}
      <h5 style={styles.transactionCount}>Final transaction count: {total}</h5>
    </Modal.Body>
    );
  }

  renderModalFooter(closeModal, handleSubmit, soidShouldBeGenResolve, reasonDropDownValue, textValue, total) {
    return (
    <Modal.Footer style={
      styles.container
    }
    >
      <Button variant="secondary" onClick={closeModal}>Close</Button>
      <Button
        variant="primary"
        onClick={() => handleSubmit(soidShouldBeGenResolve, reasonDropDownValue, textValue)}
        disabled={total === 0 || textValue.trim().split(/\s+/).length < 3 || reasonDropDownValue === '' || soidShouldBeGenResolve === ''}
      >
        Submit Transactions
      </Button>
    </Modal.Footer>
    );
  }

  render() {
    const { isOpen, closeModal, } = this.props;
    const total = this.calculateTotal();

    return (
    <Modal show={isOpen} onHide={closeModal} centered size="lg">
      {this.renderModalHeader()}
      {this.renderModalBody(total)}
      {this.renderModalFooter(
        closeModal,
        this.props.handleSubmit,
        this.state.soidShouldBeGenResolve,
        this.state.reasonDropDownValue,
        this.state.textValue,
        total
      )}
    </Modal>
    );
  }
}

TransactionConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  transactions: PropTypes.object.isRequired,
  selectedLineItems: PropTypes.object.isRequired,
};

export default TransactionConfirmationModal;
